var React = require('react');

var Footer = React.createClass({
  render: function(){
    return (
      <div>
           <footer id="footer">
              <div className="footer-bottom">
                 <div className="container">
                    <div className="row">
                       <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 "> &copy; Copyright 2018 by <a href="#">Ouvidoria Sistema Sebrae</a>. All Rights Reserved. </div>
                       {/* <div className="col-lg-6 col-md-6 col-xs-12 col-sm-6 ">
                          <ul className="social social-icons-footer-bottom">
                             <li className="facebook"><a href="#" data-toggle="tooltip" title="Facebook"><i className="fa fa-facebook"></i></a></li>
                             <li className="twitter"><a href="#" data-toggle="tooltip" title="Twitter"><i className="fa fa-twitter"></i></a></li>
                             
                             <li className="linkedin"><a href="#" data-toggle="tooltip" title="LinkedIn"><i className="fa fa-linkedin"></i></a></li>
                             <li className="rss"><a href="#" data-toggle="tooltip" title="Rss"><i className="fa fa-rss"></i></a></li>
                          </ul>
                       </div> */}
                    </div>
                 </div>
              </div>
           </footer>
      </div>  
    )
  }
});

module.exports = Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Footer.js
 **/